import { Spinner, Text } from "@chakra-ui/react";
import { cn } from "utils/helpers";

type Props = {
	className?: string;
	fontSize?: "sm" | "md" | "lg" | "xl";
	horizontal?: boolean;
	label?: string;
	spinnerSize?: "sm" | "md" | "lg" | "xl";
	textClassName?: string;
	verticalPadding?: number;
};

export const LoadingSpinner = ({
	className,
	fontSize = "md",
	horizontal = false,
	label = "Loading...",
	spinnerSize: size = "lg",
	textClassName,
	verticalPadding = 16,
}: Props) => {
	return (
		<div
			className={cn(
				"flex flex-col items-center justify-center gap-y-4",
				`py-${verticalPadding}`,
				className,
				horizontal ? "flex-row" : "flex-col"
			)}
		>
			<Spinner
				size={size}
				color="primary"
			/>
			{label ? (
				<Text
					className={textClassName}
					fontSize={fontSize}
					paddingLeft={horizontal && 2}
				>
					{label}
				</Text>
			) : null}
		</div>
	);
};
